module.exports = __webpack_public_path__ + "img/3.27_Russian_road_sign.d84d5814.svg";